import React from "react";

const Male = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.25 2.75H12.5V4.75H17.8183L12.6337 9.93463C12.1435 9.5761 11.608 9.29519 11.0279 9.09216C10.376 8.86398 9.69958 8.75 9 8.75C7.87778 8.75 6.83413 9.03512 5.87378 9.60451C4.91506 10.1573 4.15019 10.9144 3.58184 11.8724L3.58027 11.8752C3.02684 12.8355 2.75 13.8787 2.75 15C2.75 16.1213 3.02682 17.1645 3.58025 18.1248L3.58186 18.1276C4.1501 19.0854 4.91455 19.8499 5.87244 20.4182L5.87518 20.4197C6.83554 20.9732 7.87867 21.25 9 21.25C10.1213 21.25 11.1645 20.9732 12.1248 20.4198L12.1276 20.4181C13.0856 19.8498 13.8427 19.0849 14.3955 18.1262C14.9649 17.1659 15.25 16.1222 15.25 15C15.25 14.3004 15.136 13.624 14.9078 12.9721C14.7048 12.392 14.4239 11.8565 14.0654 11.3663L19.25 6.18168V11.5H21.25V2.75ZM9 10.75C9.76858 10.75 10.4745 10.9415 11.1228 11.3246C11.774 11.7094 12.2906 12.226 12.6754 12.8772C13.0585 13.5255 13.25 14.2314 13.25 15C13.25 15.7686 13.0585 16.4745 12.6754 17.1228C12.2906 17.774 11.774 18.2906 11.1228 18.6754C10.4745 19.0585 9.76858 19.25 9 19.25C8.23142 19.25 7.52546 19.0585 6.87718 18.6754C6.22599 18.2906 5.7094 17.774 5.32461 17.1228C4.94153 16.4745 4.75 15.7686 4.75 15C4.75 14.2314 4.94153 13.5255 5.32461 12.8772C5.7094 12.226 6.22599 11.7094 6.87718 11.3246C7.52546 10.9415 8.23142 10.75 9 10.75Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Female = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43853 13.4027C9.22189 13.93 10.0765 14.2692 11 14.4193V17H8V19H11V22H13V19H16V17H13V14.4193C13.9227 14.2691 14.7702 13.9296 15.5399 13.4014L15.5407 13.4009C16.3855 12.816 17.0455 12.0751 17.5176 11.1798C18.0057 10.2684 18.25 9.29059 18.25 8.25C18.25 7.12781 17.9649 6.08418 17.3955 5.12384C16.8426 4.16491 16.0851 3.40739 15.1262 2.85449C14.1658 2.28511 13.1222 2 12 2C10.8778 2 9.83416 2.28511 8.87382 2.85449C7.91508 3.40728 7.15019 4.16436 6.58184 5.12244L6.58027 5.12518C6.02684 6.08554 5.75 7.12867 5.75 8.25C5.75 9.28939 5.98583 10.2664 6.45764 11.1775L6.46021 11.1822C6.9472 12.075 7.60569 12.815 8.43392 13.3996L8.43853 13.4027ZM12 4C12.7686 4 13.4745 4.19153 14.1228 4.57461C14.774 4.9594 15.2906 5.47599 15.6754 6.12718C16.0585 6.77546 16.25 7.48142 16.25 8.25C16.25 9.01858 16.0585 9.72454 15.6754 10.3728C15.2906 11.024 14.774 11.5406 14.1228 11.9254C13.4745 12.3085 12.7686 12.5 12 12.5C11.2314 12.5 10.5255 12.3085 9.87718 11.9254C9.22599 11.5406 8.7094 11.024 8.32461 10.3728C7.94153 9.72454 7.75 9.01858 7.75 8.25C7.75 7.48142 7.94153 6.77546 8.32461 6.12718C8.7094 5.47599 9.22599 4.9594 9.87718 4.57461C10.5255 4.19153 11.2314 4 12 4Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Down = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09331 6.66223L0.618954 2.42694C0.524989 2.26491 0.474409 2.08138 0.4721 1.89408C0.469792 1.70679 0.515833 1.52206 0.605777 1.35776C0.696263 1.19254 0.829373 1.05459 0.991254 0.958255C1.15313 0.861921 1.33787 0.810727 1.52625 0.809999L6.47495 0.809999C6.66349 0.810559 6.84842 0.861674 7.01048 0.958017C7.17255 1.05436 7.3058 1.1924 7.39636 1.35776C7.48622 1.52192 7.53222 1.70648 7.52992 1.89361C7.52761 2.08074 7.47707 2.26411 7.38319 2.426L4.90789 6.66129C4.81597 6.82059 4.68372 6.95287 4.52446 7.04485C4.36519 7.13682 4.18452 7.18524 4.0006 7.18524C3.81668 7.18524 3.63601 7.13682 3.47674 7.04485C3.31748 6.95287 3.18523 6.82153 3.09331 6.66223Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Poses = ({ active, className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // class={`icon${props.active ? " active " : ""} ${props.className}`}
    >
      <path
        d="M5.16 6.15998C5.621 5.61998 6.146 5.13898 6.722 4.72198"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 19.482C15.57 20.44 13.851 21 12 21C11.088 21 10.209 20.862 9.38 20.61"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.349 19C5.068 17.965 4.084 16.583 3.523 15"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.523 9C3.19 9.94 3 10.946 3 12"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.463 17C20.427 15.569 21 13.855 21 12C21 7.029 16.971 3 12 3"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.768 7.73201C14.744 8.70801 14.744 10.291 13.768 11.268C12.792 12.245 11.209 12.244 10.232 11.268C9.255 10.292 9.256 8.70901 10.232 7.73201C11.208 6.75501 12.791 6.75601 13.768 7.73201Z"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16C16.369 15.671 16.166 15.375 15.906 15.134C15.467 14.726 14.892 14.5 14.292 14.5C13.292 14.5 10.708 14.5 9.708 14.5C9.108 14.5 8.534 14.727 8.094 15.134C7.834 15.375 7.631 15.671 7.5 16"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Styles = ({ active, className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // class={`icon${props.active ? " active " : ""} ${props.className}`}
    >
      <path
        d="M7.33713 16.1137L3.61668 12.4729C2.79444 11.6682 2.79444 10.3644 3.61668 9.55979L9.21824 4.07806L15.9154 10.632L10.3139 16.1137C9.49165 16.9174 8.15837 16.9174 7.33713 16.1137V16.1137Z"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8952 14.689C19.0341 14.8605 19.187 15.0572 19.3392 15.2684C19.5887 15.6144 19.8258 15.9845 19.9978 16.3349C20.177 16.6999 20.25 16.9732 20.25 17.1451C20.25 17.8494 19.6534 18.4558 18.8952 18.4558C18.1367 18.4558 17.5403 17.8492 17.5403 17.1461C17.5403 16.9739 17.6134 16.7003 17.7925 16.3352C17.9645 15.9847 18.2017 15.6146 18.4512 15.2685C18.6034 15.0573 18.7563 14.8605 18.8952 14.689Z"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.21823 4.08L8.13451 3"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9196 10.6281H3.03424"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.52124 21H12.0518"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Walking = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        d="M12.452 5.97052C13.6865 5.97052 14.6872 4.96976 14.6872 3.73526C14.6872 2.50076 13.6865 1.5 12.452 1.5C11.2175 1.5 10.2167 2.50076 10.2167 3.73526C10.2167 4.96976 11.2175 5.97052 12.452 5.97052Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
      <path
        d="M17.6337 12.0667L15.7033 10.3394C15.7033 10.3394 14.5856 8.40899 14.1792 7.59616C14.0776 7.29136 13.7728 6.98655 12.3504 6.88495C11.5376 6.88495 10.9279 6.88495 10.5215 6.88495C9.91191 6.88495 9.20069 7.39296 8.69268 7.59616C7.67665 8.10418 7.27024 8.51059 7.06704 8.61219L6.96544 8.71379C6.86383 8.81539 6.76223 9.0186 6.76223 9.1202C6.76223 9.1202 5.7462 11.7619 5.7462 11.8635C5.6446 12.0667 5.6446 12.2699 5.7462 12.5747C5.94941 13.1843 6.35582 13.4891 6.96544 13.2859C7.37185 13.1843 7.57505 12.8795 7.67665 12.5747L8.59108 10.2378C8.69268 9.93302 9.5055 9.62822 9.5055 9.62822C9.5055 10.1362 9.09909 13.3875 9.09909 13.5907L8.69268 17.0452V17.1468L6.15261 20.4997C6.05101 20.7029 5.94941 20.9061 5.84781 21.1093C5.7462 21.7189 6.25422 22.2269 6.86383 22.3286C7.27024 22.3286 7.57505 22.2269 7.87986 21.9221C7.87986 21.9221 10.4199 18.7725 10.8263 18.2644C10.9279 18.1628 10.9279 18.0612 10.9279 17.9596C10.9279 17.9596 11.1311 17.2484 11.436 15.6228C11.436 15.4196 11.5376 15.318 11.5376 15.1148L13.3664 17.7564C13.468 17.858 13.5696 18.0612 13.6712 18.2644L14.8904 21.8205C14.992 22.0237 15.0936 22.2269 15.2969 22.3286C15.8049 22.6334 16.5161 22.5318 16.8209 22.0237C17.0241 21.7189 17.0241 21.3125 16.9225 21.0077L15.7033 17.0452C15.7033 16.9436 15.5001 16.7404 15.5001 16.6388C15.3985 16.4356 15.0936 15.7244 14.484 15.0132C14.1792 14.6068 13.976 14.2003 13.7728 13.9971C13.6712 13.8955 13.6712 13.7939 13.6712 13.6923C13.6712 13.2859 13.7728 11.6603 13.8744 11.2539C13.976 11.3555 13.976 11.4571 14.0776 11.5587C14.1792 11.6603 14.2808 11.8635 14.3824 11.9651L16.5161 13.8955C16.7193 13.9971 16.9225 14.0987 17.1257 14.0987C17.7353 14.2003 18.2433 13.6923 18.3449 13.0827C18.0401 12.6763 17.8369 12.2699 17.6337 12.0667Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Running = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        d="M14.9368 6.56001C16.1518 6.56001 17.1368 5.57503 17.1368 4.36001C17.1368 3.14498 16.1518 2.16 14.9368 2.16C13.7218 2.16 12.7368 3.14498 12.7368 4.36001C12.7368 5.57503 13.7218 6.56001 14.9368 6.56001Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
      <path
        d="M20.4368 9.86C20.1368 9.56 19.7368 9.56 19.4368 9.66L17.1368 10.16L15.4368 8.36C15.2368 8.16 15.0368 7.96 14.2368 7.66C12.6368 7.06 11.9368 6.96 11.9368 6.96C11.9368 6.96 11.5368 6.86 11.3368 6.96C11.1368 6.96 10.7368 6.96 10.0368 6.96C8.93682 6.96 8.53682 7.06 8.43682 7.06C8.33682 7.06 8.23682 7.16 8.23682 7.16C8.13682 7.26 8.03682 7.26 7.93682 7.36C7.53682 7.76 5.93682 9.56 5.93682 9.56C5.83682 9.76 5.73682 9.96 5.63682 10.16C5.53682 10.76 6.03682 11.26 6.63682 11.36C7.03682 11.36 7.33682 11.26 7.63682 10.96L9.23682 9.06H10.5368C10.3368 9.56 10.1368 10.06 9.83682 10.56C9.33682 11.76 9.03682 12.36 8.93682 12.66L7.63682 15.16H4.23682C4.03682 15.16 3.83682 15.26 3.63682 15.36C3.13682 15.76 3.03682 16.36 3.43682 16.86C3.63682 17.16 4.03682 17.36 4.33682 17.26C4.33682 17.26 8.53682 17.26 8.63682 17.26C8.93682 17.26 9.23682 17.06 9.33682 16.86C9.33682 16.76 10.6368 14.86 10.7368 14.66L12.8368 16.86L13.5368 20.46C13.5368 20.76 13.6368 20.86 13.7368 21.16C13.9368 21.76 14.5368 21.96 15.1368 21.76C15.5368 21.66 15.6368 21.46 15.7368 21.16C15.8368 21.06 15.8368 20.76 15.8368 20.66C15.8368 19.56 15.3368 16.86 15.2368 16.66C15.1368 16.46 15.1368 16.16 15.0368 15.96C15.0368 15.96 14.8368 15.26 13.6368 14.16C13.4368 13.96 13.2368 13.76 13.0368 13.56C13.1368 13.26 13.3368 13.06 13.4368 12.76C13.6368 12.26 14.1368 11.16 14.4368 10.56C14.5368 10.66 14.7368 10.86 14.9368 11.06C15.8368 11.96 16.3368 12.16 16.3368 12.16C16.5368 12.26 16.8368 12.36 17.1368 12.26L20.0368 11.66C20.0368 11.66 20.4368 11.56 20.6368 11.36C20.9368 10.96 20.8368 10.26 20.4368 9.86Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Standing = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        d="M12.1129 5.6434C13.3952 5.6434 14.4346 4.60394 14.4346 3.3217C14.4346 2.03946 13.3952 1 12.1129 1C10.8307 1 9.79124 2.03946 9.79124 3.3217C9.79124 4.60394 10.8307 5.6434 12.1129 5.6434Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
      <path
        d="M18.1283 12.3974L16.1232 10.3923C16.1232 10.2868 14.9623 8.59828 14.6457 8.07063C14.2236 7.3319 13.8015 7.01531 13.6959 7.01531C13.3793 6.90978 12.9572 6.90977 12.4296 6.90977C11.0576 6.90977 10.3189 6.90978 10.0023 7.22637C9.79127 7.3319 9.5802 7.75403 9.36914 8.07063C8.94701 8.59828 7.8917 10.2868 7.8917 10.2868L5.8866 12.2919C5.67553 12.503 5.57 12.8195 5.57 13.2417C5.67553 13.7693 6.20319 14.1915 6.73085 14.0859C7.04744 13.9804 7.25851 13.8749 7.36404 13.7693C7.8917 13.2417 8.94701 12.2919 9.26361 11.6587C9.36914 11.4476 9.58021 11.0255 9.68574 10.92L9.47467 13.1361L7.78617 21.4732C7.68063 21.6842 7.78617 21.8953 7.8917 22.2119C8.10276 22.8451 8.84148 23.0561 9.36914 22.8451C9.79127 22.7395 10.0023 22.3174 10.1079 22.0008L11.6908 14.5081H12.0074L12.324 21.8953C12.324 22.1063 12.4296 22.3174 12.5351 22.5285C12.9572 23.0561 13.5904 23.1617 14.1181 22.7395C14.4347 22.5285 14.6457 22.1063 14.6457 21.7897L14.3291 13.7693C14.3291 13.1361 14.2236 11.9753 14.2236 11.0255C14.2236 11.131 14.5402 11.5532 14.5402 11.6587C14.5402 11.6587 15.8066 13.0306 16.6508 13.7693C16.9674 14.0859 17.1785 14.0859 17.284 14.1915C17.8117 14.297 18.3393 13.9804 18.4449 13.3472C18.4449 12.9251 18.3393 12.6085 18.1283 12.3974Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Cycling = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        d="M14.2 6.29999C15.415 6.29999 16.4 5.31502 16.4 4.09999C16.4 2.88496 15.415 1.89999 14.2 1.89999C12.985 1.89999 12 2.88496 12 4.09999C12 5.31502 12.985 6.29999 14.2 6.29999Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
      <path
        d="M18.3 14C18.1 14 17.9 14 17.8 14C17.8 14 17.4 12.3 17.3 12.3L16.8 10.7C17.1 10.4 17.1 9.89999 16.8 9.49999C16.6 9.19999 16.3 9.09999 15.9 9.09999L13.7 8.99999L12.8 7.49999C12.7 7.39999 12.5 7 12.3 6.9C11 5.8 10 6.59999 10 6.59999C10 6.59999 9.1 7.19998 8 8.69998C6.9 10.2 6.8 10.6 6.8 11.3C6.8 11.8 7 12.6 8 13L10.7 14.2L10.6 17.9C10.6 17.9 10.7 18.4 10.8 18.5C11.2 19 11.9 19.1 12.3 18.7C12.6 18.5 12.8 18.1 12.7 17.8C12.7 17.8 12.8 13.6 12.7 13.5C12.7 13.2 12.5 12.9 12.4 12.7C12.4 12.7 12 12.2 10.6 11.4C10.5 11.3 10.4 11.3 10.3 11.2C10.7 10.7 11.2 10.2 11.6 9.59999C12.2 10.5 12.5 10.7 12.5 10.7C12.7 10.9 12.9 11 13.2 11H15.8L16 11.9L13.7 13.7C13.5 13.9 13.5 14.2 13.7 14.4C13.8 14.5 13.9 14.6 14.1 14.6C14.2 14.6 14.3 14.6 14.4 14.5L16.4 13.1L16.7 14.3C15.2 14.9 14.2 16.4 14.2 18C14.2 20.2 16 22 18.2 22C20.4 22 22.2 20.2 22.2 18C22.3 15.8 20.5 14 18.3 14ZM18.3 20.9C16.7 20.9 15.4 19.6 15.4 18C15.4 16.8 16.1 15.9 17.1 15.4L17.8 18.1C17.9 18.3 18.1 18.5 18.3 18.5H18.4C18.7 18.4 18.8 18.2 18.8 17.9L18.1 15.2C18.2 15.2 18.3 15.2 18.3 15.2C19.9 15.2 21.2 16.5 21.2 18.1C21.1 19.6 19.9 20.9 18.3 20.9Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
      <path
        d="M9.7 15.1C9.9 14.9 9.9 14.6 9.7 14.4C9.5 14.2 9.2 14.2 9 14.4L8.4 15C7.7 14.4 6.8 14.1 5.8 14.1C3.6 14.1 1.8 15.9 1.8 18.1C1.8 20.3 3.6 22.1 5.8 22.1C8 22.1 9.8 20.3 9.8 18.1C9.8 17.2 9.5 16.4 9 15.7L9.7 15.1ZM5.9 20.9C4.3 20.9 3 19.6 3 18C3 16.4 4.3 15.1 5.9 15.1C6.5 15.1 7.1 15.3 7.6 15.7L5.6 17.7C5.5 17.8 5.4 18.1 5.5 18.2C5.6 18.4 5.8 18.5 6 18.5H8.8C8.5 19.9 7.3 20.9 5.9 20.9ZM6.9 17.6L8.3 16.5C8.5 16.8 8.7 17.2 8.7 17.6H6.9Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Colorful = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        d="M12 2C6.47778 2 2 6.47778 2 12C2 17.5222 6.47778 22 12 22C12.9222 22 13.6667 21.2556 13.6667 20.3333C13.6667 19.9 13.5 19.5111 13.2333 19.2111C12.9778 18.9222 12.8111 18.5333 12.8111 18.1111C12.8111 17.1889 13.5556 16.4444 14.4778 16.4444H16.4444C19.5111 16.4444 22 13.9556 22 10.8889C22 5.97778 17.5222 2 12 2ZM5.88889 12C4.96667 12 4.22222 11.2556 4.22222 10.3333C4.22222 9.41111 4.96667 8.66667 5.88889 8.66667C6.81111 8.66667 7.55556 9.41111 7.55556 10.3333C7.55556 11.2556 6.81111 12 5.88889 12ZM9.22222 7.55556C8.3 7.55556 7.55556 6.81111 7.55556 5.88889C7.55556 4.96667 8.3 4.22222 9.22222 4.22222C10.1444 4.22222 10.8889 4.96667 10.8889 5.88889C10.8889 6.81111 10.1444 7.55556 9.22222 7.55556ZM14.7778 7.55556C13.8556 7.55556 13.1111 6.81111 13.1111 5.88889C13.1111 4.96667 13.8556 4.22222 14.7778 4.22222C15.7 4.22222 16.4444 4.96667 16.4444 5.88889C16.4444 6.81111 15.7 7.55556 14.7778 7.55556ZM18.1111 12C17.1889 12 16.4444 11.2556 16.4444 10.3333C16.4444 9.41111 17.1889 8.66667 18.1111 8.66667C19.0333 8.66667 19.7778 9.41111 19.7778 10.3333C19.7778 11.2556 19.0333 12 18.1111 12Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Duotone = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 19.5V12V4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z"
        // fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

const Outline = ({ active, className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9194 2C17.4872 2 22 6.47667 22 12C22 17.5233 17.4872 22 11.9194 22"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.47511 21.3878C7.35952 20.9844 6.33353 20.4 5.44196 19.6578"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44196 4.34222C6.33353 3.59889 7.35952 3.01444 8.47511 2.61222"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 10.2644C2.20721 9.09444 2.61716 7.99556 3.19512 7.00333"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 13.7344C2.20721 14.9044 2.61716 16.0033 3.19512 16.9956"
        stroke={props.fill ? props.fill : "#363D61"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Backdrops = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.001 19C13.4586 19 14.8565 18.4249 15.8876 17.4011C16.9187 16.3773 17.4987 14.9886 17.5 13.54C17.502 10.5921 14.3296 7.20439 12.8057 5.39206C12.7106 5.27002 12.5886 5.17124 12.4491 5.10329C12.3096 5.03533 12.1563 5 12.001 5C11.8457 5 11.6924 5.03533 11.5529 5.10329C11.4134 5.17124 11.2915 5.27002 11.1963 5.39206C9.67547 7.20439 6.5 10.5032 6.5 13.54C6.5016 14.9888 7.08191 16.3777 8.1134 17.4015C9.14489 18.4253 10.5432 19.0003 12.001 19ZM13.5561 16.5609C12.8982 16.9582 12.1252 17.1247 11.3608 17.0336C10.5965 16.9426 9.88495 16.5993 9.34019 16.0587C8.79543 15.5181 8.44894 14.8115 8.35617 14.052C8.26341 13.2925 8.42974 12.5241 8.82855 11.8697C8.88757 11.7832 8.96572 11.7114 9.05701 11.6597C9.1483 11.608 9.25029 11.5777 9.35517 11.5713C9.46005 11.5648 9.56503 11.5823 9.66205 11.6224C9.75907 11.6625 9.84555 11.7242 9.91487 11.8027L13.6214 15.4803C13.7012 15.5487 13.764 15.6344 13.8051 15.7308C13.8461 15.8272 13.8643 15.9317 13.8581 16.0362C13.852 16.1406 13.8218 16.2423 13.7697 16.3333C13.7177 16.4243 13.6453 16.5022 13.5581 16.5609H13.5561Z"
      />
    </svg>
  );
};

const Remix = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        d="M7.05025 7.05025C6.07152 8.02898 5.40492 9.27589 5.1347 10.6334C4.86447 11.9909 5.00276 13.398 5.53208 14.6769C6.0614 15.9559 6.95798 17.0491 8.10852 17.8186C9.25905 18.5881 10.6119 18.9992 11.996 19C13.3801 19.0008 14.7334 18.5912 15.8848 17.8231C17.0362 17.0549 17.9341 15.9626 18.4649 14.6843C18.9956 13.406 19.1355 11.999 18.8669 10.6412C18.5982 9.28343 17.933 8.03575 16.9554 7.05591C16.3057 6.40468 15.5339 5.88791 14.6843 5.53514C13.8347 5.18237 12.9239 5.00052 12.004 5C11.0841 4.99947 10.1731 5.18028 9.32306 5.53208C8.47306 5.88388 7.70073 6.39977 7.05025 7.05025L7.05025 7.05025ZM11.6875 7.59755C11.8643 7.43378 12.0859 7.32633 12.324 7.28885C12.5621 7.25137 12.806 7.28556 13.0246 7.38708C13.2433 7.4886 13.4268 7.65286 13.5518 7.85895C13.6768 8.06505 13.7377 8.30367 13.7267 8.54447C13.7157 8.78526 13.6333 9.01735 13.4901 9.2112C13.3468 9.40505 13.1491 9.55191 12.9221 9.63309C12.6952 9.71427 12.4492 9.72611 12.2155 9.66709C11.9818 9.60808 11.7709 9.48088 11.6097 9.30168C11.3964 9.06425 11.2851 8.7525 11.2996 8.43369C11.3142 8.11488 11.4535 7.81457 11.6875 7.59755ZM7.62937 11.6556C7.79911 11.4851 8.01568 11.3687 8.25163 11.3214C8.48757 11.2741 8.73226 11.2979 8.95466 11.3898C9.17706 11.4817 9.36716 11.6376 9.50085 11.8376C9.63455 12.0377 9.70581 12.273 9.70561 12.5137C9.70542 12.7543 9.63376 12.9895 9.49974 13.1893C9.36571 13.3892 9.17536 13.5448 8.9528 13.6363C8.73025 13.7279 8.48552 13.7512 8.24966 13.7035C8.0138 13.6558 7.79741 13.5391 7.62795 13.3683C7.40146 13.1406 7.27437 12.8326 7.2745 12.5114C7.27463 12.1903 7.40198 11.8824 7.62866 11.6549L7.62937 11.6556ZM16.2737 13.4142C16.1379 13.9808 15.8761 14.5094 15.5077 14.9608C15.1393 15.4122 14.6739 15.7747 14.1461 16.0213C13.5856 16.289 12.9669 16.4117 12.3467 16.3781C11.7265 16.3445 11.1246 16.1557 10.5964 15.829C10.5231 15.7796 10.4616 15.7147 10.4163 15.6388C10.371 15.5629 10.343 15.4779 10.3343 15.39C10.3257 15.302 10.3366 15.2132 10.3662 15.13C10.3959 15.0467 10.4436 14.971 10.5059 14.9083L14.8935 10.5207C14.9586 10.4564 15.0374 10.4075 15.124 10.3779C15.2106 10.3482 15.3028 10.3385 15.3937 10.3494C15.4846 10.3604 15.5718 10.3917 15.6489 10.4411C15.726 10.4905 15.7909 10.5566 15.8389 10.6346C16.0958 11.0442 16.2668 11.5017 16.3414 11.9794C16.4161 12.4572 16.3928 12.9451 16.273 13.4135L16.2737 13.4142Z"
      />
    </svg>
  );
};

const Close = ({ active, className, ...props }) => {
  const classNames = [`icon-${active ? "active" : "gray"}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.70711 0.292893C1.31658 -0.0976311 0.683418 -0.0976311 0.292894 0.292893C-0.0976301 0.683417 -0.0976301 1.31658 0.292894 1.70711L2.58579 4L0.292894 6.29289C-0.09763 6.68342 -0.09763 7.31658 0.292894 7.70711C0.683419 8.09763 1.31658 8.09763 1.70711 7.70711L4 5.41421L6.29289 7.70711C6.68342 8.09763 7.31658 8.09763 7.70711 7.70711C8.09763 7.31658 8.09763 6.68342 7.70711 6.29289L5.41421 4L7.70711 1.70711C8.09763 1.31658 8.09763 0.683417 7.70711 0.292893C7.31658 -0.0976311 6.68342 -0.0976311 6.29289 0.292893L4 2.58579L1.70711 0.292893Z"
        fill={props.fill ? props.fill : "#363D61"}
      />
    </svg>
  );
};

export default {
  Male,
  Female,
  Down,
  Poses,
  Styles,
  Walking,
  Running,
  Standing,
  Cycling,
  Colorful,
  Duotone,
  Outline,
  Backdrops,
  Close,
  Remix
};
